module.exports = __webpack_public_path__ + "c2184673a7ff460f7c01a2ea017657f5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/wall_items/rocket-poster.png
// module id = 3438
// module chunks = 0